import { api } from '~/services/api'

const endpoints = {
  stats: 'dashboard-stats',
  notification: 'notifications',
  markAllSeen: 'notifications/mark-all-seen',
  markOneSeen: (id: number | string | undefined) =>
    `notifications/${id}/mark-one-seen`,
}

export const getStates = async () => {
  const { data } = await api.baseEndPoint.get(endpoints.stats)

  return data
}

export const getNotifications = async () => {
  const { data } = await api.baseEndPoint.get(endpoints.notification)
  return data
}

export const markOneSeen = async (id: any): Promise<any> => {
  const response = await api.baseEndPoint.put(endpoints.markOneSeen(id))

  return response.data
}

export const markAllSeen = async () => {
  const response = await api.baseEndPoint.put(endpoints.markAllSeen)

  return response.data
}
